import { render } from "./jobsComponent.vue?vue&type=template&id=55636791&scoped=true"
import script from "./jobsComponent.vue?vue&type=script&lang=js"
export * from "./jobsComponent.vue?vue&type=script&lang=js"

import "./jobsComponent.vue?vue&type=style&index=0&id=55636791&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55636791"]])

export default __exports__